import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Calculators.module.css";
import { Routes, Route } from "react-router-dom";

import { FaArrowLeft } from "react-icons/fa";

import ConcreteBending from "../../calculators/pages/concrete/ConcreteBending";
import ConcreteShear from "../../calculators/pages/concrete/ConcreteShear";
import ConcreteTorsion from "../../calculators/pages/concrete/ConcreteTorsion";
import ConcreteShearTorsion from "../../calculators/pages/concrete/ConcreteShearTorsion";
import ConcreteAnchorageLength from "../../calculators/pages/concrete/ConcreteAnchorageLength";
import ConcreteSplice from "../../calculators/pages/concrete/ConcreteSplice";
import ConcreteFatigue from "../../calculators/pages/concrete/ConcreteFatigue";

import SteelTension from "../../calculators/pages/steel/SteelTension";
import SteelCompression from "../../calculators/pages/steel/SteelCompression";

import TimberTension from "../../calculators/pages/timber/TimberTension";
import TimberCompression from "../../calculators/pages/timber/TimberCompression";
import TimberShear from "../../calculators/pages/timber/TimberShear";
import TimberBending from "../../calculators/pages/timber/TimberBending";
import TimberBendingOblique from "../../calculators/pages/timber/TimberBendingOblique";
import TimberBendingCombined from "../../calculators/pages/timber/TimberBendingCombined";
import TimberBendingCombinedOblique from "../../calculators/pages/timber/TimberBendingCombinedOblique";

import { IconButton } from "@chakra-ui/react";

function Calculators({ calculators }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCalculator, setSelectedCalculator] = useState("/calculadoras");

  useEffect(() => {
    setSelectedCalculator(location.pathname);
    console.log(location.pathname);
  }, [location]);

  return (
    <>
      {selectedCalculator !== "/calculadoras" && (
        <div className={styles.section} key={"return"}>
          <IconButton
            variant={"icon"}
            icon={<FaArrowLeft />}
            onClick={() => navigate("/calculadoras")}
          />
        </div>
      )}
      {selectedCalculator === "/calculadoras" && (
        <>
          {Object.entries(calculators).map(([subject, subjectInfos], i) => (
            <div className={styles.section} key={"menu"}>
              <div className={styles.sectionHeader}>
                <img
                  src={require("../utils/img/" + subjectInfos["icon"])}
                  alt={`${subject} icon`}
                ></img>
                <h1>{subject}</h1>
              </div>
              <div className={styles.sectionSeparator}></div>
              <div className={styles.cards}>
                {subjectInfos["calculators"].map((calculator, j) => (
                  <div
                    className={styles.card}
                    key={j}
                    onClick={() =>
                      navigate("/calculadoras" + calculator["path"])
                    }
                  >
                    {calculator["name"]}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
      <Routes>
        {/* CONCRETE */}
        <Route
          path="/concreto/flexao-simples-normal"
          element={<ConcreteBending />}
        />
        <Route path="/concreto/cisalhamento" element={<ConcreteShear />} />
        <Route path="/concreto/torcao" element={<ConcreteTorsion />} />
        <Route
          path="/concreto/cisalhamento-e-torcao"
          element={<ConcreteShearTorsion />}
        />
        <Route
          path="/concreto/comprimento-de-ancoragem"
          element={<ConcreteAnchorageLength />}
        />
        <Route path="/concreto/traspasse" element={<ConcreteSplice />} />
        <Route path="/concreto/fadiga" element={<ConcreteFatigue />} />
        {/* STEEL */}
        <Route path="/aco/tracao" element={<SteelTension />} />
        {/* <Route path="/aco/compressao" element={<SteelCompression />} /> */}
        {/* TIMBER */}
        <Route path="/madeira/tracao" element={<TimberTension />} />
        <Route path="/madeira/compressao" element={<TimberCompression />} />
        <Route path="/madeira/cisalhamento" element={<TimberShear />} />
        <Route
          path="/madeira/flexao-simples-normal"
          element={<TimberBending />}
        />
        <Route
          path="/madeira/flexao-simples-obliqua"
          element={<TimberBendingOblique />}
        />
        <Route
          path="/madeira/flexao-composta-normal"
          element={<TimberBendingCombined />}
        />
        <Route
          path="/madeira/flexao-composta-obliqua"
          element={<TimberBendingCombinedOblique />}
        />
      </Routes>
    </>
  );
}

export default Calculators;
